import { render, staticRenderFns } from "./OrderCenterList.vue?vue&type=template&id=6a8c4838&scoped=true"
import script from "./OrderCenterList.vue?vue&type=script&lang=js"
export * from "./OrderCenterList.vue?vue&type=script&lang=js"
import style0 from "./OrderCenterList.vue?vue&type=style&index=0&id=6a8c4838&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8c4838",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a8c4838')) {
      api.createRecord('6a8c4838', component.options)
    } else {
      api.reload('6a8c4838', component.options)
    }
    module.hot.accept("./OrderCenterList.vue?vue&type=template&id=6a8c4838&scoped=true", function () {
      api.rerender('6a8c4838', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/plugin/order-receive/center/OrderCenterList.vue"
export default component.exports